import React from 'react';
import { tableData } from './admin.utils';

export type SortType = 'asc' | 'desc';

export const usePaginatedTable = <T,>(data: T[], defaultLimit = 50) => {
    const [page, setPage] = React.useState(1);
    const [limit, setLimit] = React.useState(defaultLimit);
    const [sortColumn, setSortColumn] = React.useState<string>();
    const [sortType, setSortType] = React.useState<SortType>('asc');

    const sorted = React.useMemo(
        () => tableData(data, sortColumn, sortType),
        [data, sortColumn, sortType],
    );

    const total = sorted.length;
    const totalPages = Math.max(1, Math.ceil(total / limit));

    React.useEffect(() => {
        if (page > totalPages) {
            setPage(totalPages);
        }
    }, [page, totalPages]);

    const pageData = React.useMemo(() => {
        const start = limit * (page - 1);
        const end = start + limit;

        return sorted.filter((_, i) => i >= start && i < end);
    }, [sorted, page, limit]);

    const handleSort = (column: string) => {
        if (sortColumn === column) {
            setSortType((prev) => (prev === 'asc' ? 'desc' : 'asc'));
            return;
        }

        setSortColumn(column);
        setSortType('asc');
    };

    const setLimitAndReset = (value: number) => {
        setPage(1);
        setLimit(value);
    };

    return {
        pageData,
        page,
        setPage,
        limit,
        setLimit: setLimitAndReset,
        total,
        totalPages,
        sortColumn,
        sortType,
        handleSort,
    };
};
